// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Se-z","articleImagesWrap":"Te-z","articleImage":"Ue-z","singleImage":"Ve-z"};